import { useState } from 'react'
import { useAsync } from 'react-use'
import { config } from '~/shared'
import { getApiClient } from '../../stores'
import { getIntegrationsFromBot } from '../../features/bots/services'
import { useQuery } from '../../services'

export const useWebchatEmbedScript = ({ botId, workspaceId }: { botId: string; workspaceId: string }) => {
  const [embedScript, setEmbedScript] = useState<string | null | undefined>(undefined)
  const [shareableLink, setShareableLink] = useState<string | null | undefined>(undefined)
  const bot = useQuery('workspaces_/$workspaceId_/bots_/$botId_', { botId, workspaceId }).data

  const apiClient = getApiClient({ botId, workspaceId })

  const fetchWebchatConfigFileUrl = async () => {
    const { files } = await getApiClient({ botId, workspaceId }).listFiles({
      tags: { webchatInjectConfigVersion: '1' },
    })

    const sortedFiles = files.sort((a, b) => {
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    })

    return sortedFiles[0]?.url
  }

  useAsync(async () => {
    let webchatConfigFileUrl = await fetchWebchatConfigFileUrl()

    // This is to fix an issue where some bots don't have the webchat config file
    if (!webchatConfigFileUrl) {
      const webchatIntegration = getIntegrationsFromBot(bot).find((bi) => bi.name === 'webchat')
      if (webchatIntegration?.id) {
        await apiClient.updateBot({
          id: botId,
          integrations: { [webchatIntegration.id]: { enabled: true, configuration: webchatIntegration.configuration } },
        })
        webchatConfigFileUrl = await fetchWebchatConfigFileUrl()
      }
    }

    const script = webchatConfigFileUrl
      ? `
    <script src="${config.cdnBaseUrl}/webchat/v3.3/inject.js"></script>\n<script src="${webchatConfigFileUrl}" defer></script>
    `
      : null

    setEmbedScript(script)

    const shareableConfigFile = await getApiClient({ botId, workspaceId }).listFiles({
      tags: { webchatConfigVersion: '1' },
    })

    const shareableConfigFileUrl = shareableConfigFile.files[0]?.url
    const shareableLink = shareableConfigFileUrl
      ? `${config.cdnBaseUrl}/webchat/v3.3/shareable.html?configUrl=${shareableConfigFileUrl}`
      : null
    setShareableLink(shareableLink)
  }, [botId, workspaceId])

  return { embedScript, shareableLink }
}
